import React, { useContext } from "react";
import { SlideContext } from "@layouts/SlideLayout.react";
import { Div } from "@components/Generics.react";
import { gradient } from "@utilities/helpers";
import "@styles/readers.scss";
import { clientAssetsPath } from "@api/apiV6";

export default function BackgroundImage(props) {
    const { background, paragraph, position } = props.data;
    const { colors } = useContext(SlideContext);
    const positioning = position?.split(" ");
    const popAnimation =
        positioning[1] === "center"
            ? "zoom"
            : `slide${positioning[1] === "left" ? "Right" : "Left"}`;

    // ========================= Render Function =================================
    return (
        <Div
            fluid
            fullht
            big
            flex
            column
            relative
            style={{
                backgroundImage: `url(${clientAssetsPath}/uploads/qdf/slides/${background?.id}${background?.extension})`,
                backgroundSize: "cover",
            }}
            className="background-image-template"
        >
            <Div
                wd="80%"
                noOverflow
                className={`content-position ${positioning.join("-")}`}
            >
                <Div
                    superpad
                    popAnimation={popAnimation}
                    slowAnim
                    style={{
                        background: gradient(
                            colors?.primary,
                            "to top left",
                            true
                        ),
                        color: colors?.primaryText,
                    }}
                >
                    {paragraph}
                </Div>
            </Div>
        </Div>
    );
}